import React from "react";
import lazyPage from "../../../common/helpers/lazyPage";
import PageLoader from "../../components/PageLoader";

export default lazyPage(
    "src/front/pages/404/404.tsx",
    () => import("./404"),
    <PageLoader />,
);
